<template>
  <div v-if="getAppLoader" class="main main_loader">
    <Loader class="main_loader_ch" />
  </div>
  <el-row v-else>
    <img
      :src="require('@/assets/static/images/auth_logo.svg')"
      alt="TaskPal"
      width="200"
      style="position: fixed; top: 44px; left: 56px"
    />
    <div>
      <h2>{{ $t("auth.clone.title") }}</h2>
      <h4 v-if="user_email">{{ user_email }}</h4>

      <a class="btn" href="#" @click="openTaskPal">{{
        $t("auth.clone.open")
      }}</a>

      <p v-if="user_email">
        {{ $t("auth.clone.not_you", { user_email }) }}
        <a href="/login" @click.prevent="logout">{{
          $t("auth.clone.login_other")
        }}</a>
      </p>
    </div>
    <div class="alert" v-if="alerts.length > 0">
      <div
        v-for="(alert, i) of alerts"
        :key="i"
        :class="alert.class"
        :style="alert.icon ? '' : 'justify-content: center;'"
      >
        <div class="alert-message__icon" v-if="alert.icon">
          <div
            :class="
              alert.text == $t('app.alert.synced') ? 'loader stop' : 'loader'
            "
          ></div>
        </div>
        <div class="alert-message__text">
          {{ alert.text }}
        </div>
      </div>
    </div>
  </el-row>
</template>

<script>
import { clearStorageKeepingAppearance } from "@/utils/appearanceStorage";
import { mapMutations, mapActions, mapGetters } from "vuex";

export default {
  props: {
    span: [Number],
  },
  data() {
    return {
      user_email: this.$route.query.useremail,
      app_url:
        "taskpal://clone_token=" +
        encodeURIComponent(localStorage.getItem("w_clone_token")) +
        "&token=" +
        encodeURIComponent(localStorage.getItem("w_token")),
      alerts: [],
      interval: "",
    };
  },
  sockets: {
    connect: async function () {
      console.log("Socket Connect");

      this.alerts = [
        {
          icon: true,
          text: this.$t("app.alert.syncing"),
          class: "alert-message",
        },
      ];

      clearInterval(this.interval);
      await this.handleGetData();
    },
    disconnect: async function (e) {
      console.log("Socket Disconnect");
      console.log(e.message);

      this.handleSocketDisconnected();

      setTimeout(() => {
        this.$socket.connect();
      }, 5000);

      this.interval = setInterval(() => {
        console.log("setInterval:30");
        this.$socket.connect();
      }, 30000);
    },
    connect_error: async function (e) {
      console.log("Socket Connect Error");
      console.log(e.message);
      if (e.message == "jwt expired" || e.message == "invalid signature") {
        let check_token = await this.check_token();
        if (check_token) {
          this.$socket.disconnect();
          this.syncSocketAuthorization();
          this.$socket.connect();
        } else {
          clearStorageKeepingAppearance();
          window.location.href = "/";
        }
      }
      if (e.message == "invalid token") {
        clearStorageKeepingAppearance();
        window.location.href = "/";
      }
    },
  },
  methods: {
    ...mapActions([
      "fetchUserData",
      "socket_send_firebase_token",
      "SOCKET_IN_Company",
      "getData",
      "check_token",
      "addChatUnreadMessagesRecievedWhileUpdating",
    ]),
    ...mapMutations([
      "setMessage",
      "onAppLoader",
      "offAppLoader",
      "setProjects",
      "clearComments",
      "clearTasks",
      "clearUserUsedFileSize",
      "clearUserAllFileSize",
    ]),
    syncSocketAuthorization() {
      this.$socket.io.opts.transportOptions.polling.extraHeaders.Authorization =
        localStorage.getItem("w_token");
    },
    openTaskPal() {
      var appUrl = this.app_url;
      var webFallbackUrl = "https://taskpal.com/";

      window.location.href = appUrl;

      setTimeout(function () {
        window.location.href = webFallbackUrl;
      }, 2000); // Через 2 секунды редирект, если приложение не открылось
    },
    logout() {
      this.setProjects([]);
      this.clearComments();
      this.clearUserUsedFileSize();
      this.clearUserAllFileSize();
      this.clearTasks();
      this.$socket.disconnect();
      localStorage.removeItem("w_token");
      localStorage.removeItem("w_clone_token");
      this.$router.push({
        path: "/login",
        query: {
          app: 1,
        },
      });
      console.log("User Logout");
    },
    resetSubtaskOpen() {
      const len = Object.keys(this.getTasks).length;
      if (len > 0) {
        for (let list in this.getTasks) {
          const currentProject = this.getTasks[list];
          for (let i = 0; i < currentProject.length; i++) {
            if (currentProject[i].parent && currentProject[i].unread_message) {
              localStorage.setItem(currentProject[i].parent, true);
              EventEmitter.$emit("openSubtask", currentProject[i]._id);
              i = currentProject.length + 5;
            }
          }
        }
      }
    },
    async handleGetData() {
      return await this.getData()
        .then((res) => {
          this.resetSubtaskOpen();
          this.alerts = this.alerts.filter(
            (alert) => alert.text !== this.$t("app.alert.syncing")
          );

          this.alerts.push({
            icon: true,
            text: this.$t("app.alert.synced"),
            class: "alert-message",
          });

          setTimeout(() => {
            this.addChatUnreadMessagesRecievedWhileUpdating();
          }, 0);

          setTimeout(() => {
            this.alerts = this.alerts.filter(
              (alert) => alert.text !== this.$t("app.alert.synced")
            );
          }, 1000);
        })
        .catch((err) => {
          console.log("Get Data Error", err);
          this.$socket.disconnect();
        });
    },
    handleSocketDisconnected() {
      this.alerts = [];
      this.alerts.push({
        icon: true,
        text: this.$t("app.alert.connecting"),
        class: "alert-message",
      });
    },
  },
  computed: {
    ...mapGetters(["getAppLoader", "getUserData", "getTasks"]),
    dynamicUserEmail() {
      return this.getUserData.email;
    },
  },
  mounted() {
    this.$socket.io.opts.transportOptions.polling.extraHeaders.Authorization =
      localStorage.getItem("w_token");
    this.$socket.connect();
    if (!this.user_email) {
      let findEmail = setInterval(() => {
        if (this.dynamicUserEmail) {
          clearInterval(findEmail);
          this.user_email = this.dynamicUserEmail;
          localStorage.removeItem("app_web_auth");
        }
      }, 500);
    }
  },
};
</script>

<style lang="css">
@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700&display=swap);
.auth_loader {
  display: flex !important;
  left: 0 !important;
  transform: translateX(0) !important;
  margin: 15% auto !important;
}
#app {
  background-image: none !important;
}
.logo {
  background-size: contain;
  display: inline-block;
  height: 40px;
  width: 40px;
}
dappauth-layout {
  background: white;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 4em;
}
dappauth-layout * {
  font-family: var(--theme-font);
}
dappauth-layout > div {
  padding-bottom: 3em;
}
dappauth-layout div p {
  width: 100%;
  max-width: 330px;
  margin: -1.5px auto 0;
  font-size: 12px;
  letter-spacing: initial;
  color: #464646;
}
dappauth-layout a {
  text-decoration: underline;
  color: #464646;
  transition: all ease-in-out 0.3s;
}
dappauth-layout a:hover {
  text-decoration: underline;
}
dappauth-layout a.btn {
  text-decoration: none;
  font-size: 16px;
  transition: all ease-in-out 0.3s;
  background-color: #0077ff;
  color: white;
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 15px 71.5px;
  height: auto;
  display: inline-block;
  margin: 17px 0 17px;
  border-radius: 5px;
  font-weight: bold;
  width: auto;
  border: 0;
  line-height: 18.75px;
}
dappauth-layout a.btn:hover {
  color: white;
  background: #2b8eff;
}
dappauth-layout h2 {
  margin-bottom: 0;
  font-size: 24px;
  line-height: 28.13px;
  color: #464646;
}
dappauth-layout h4 {
  margin-bottom: 0;
  font-size: 24px;
  line-height: 28.13px;
  color: #464646;
}
</style>
